<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="bank-transfer-information">
      <Title eng="BUY POINTS" jpn="ポイント購入完了" />
      <div class="area_box">
        <div class="transfer-information top-30">
          <span class="text">振込金額</span>
          <GrayBack class="shadow-box value" opacity="_60">
            <span class="price">¥{{dispSalePointPrice}}</span>
          </GrayBack>
          <span class="text top-30">振込先口座情報</span>
          <GrayBack class="shadow-box bank-account" opacity="_60">
            <div class="row">
              <span class="key">振込先金融機関</span>
              <span class="value">{{currentBank.bank}}</span>
            </div>
            <div class="row">
              <span class="key">振込先口座番号</span>
              <span class="value">{{currentBank.number}}</span>
            </div>
            <div class="row">
              <span class="key">振込先口座名</span>
              <span class="value">{{currentBank.name}}</span>
            </div>
          </GrayBack>
        </div>
        <div class="flex-box mt">
          <span class="text top">ポイントのご購入ありがとうございます。</span>
          <span class="text top">購入金額を上記の口座にお振込みください。</span>
        </div>
        <div class="flex-box">
          <span class="text bottom top-30 sp_text">営業時間(平日10時から18時)以外のお振込みの場合は、</span>
          <span class="text bottom">最短翌営業日のポイント反映となります。</span>
        </div>
      </div>
      <BlackGradationButton
        class="square-button top-30"
        text="TOPページへ"
        @handleSquareBtnClick="goToTop"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import GrayBack from '@/components/molecules/GrayBack.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title.vue';

export default {
  name: 'BankTransferInformation',

  beforeRouteLeave(to, from, next) {
    if (to.name === 'ConfirmBuyPoint') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    GrayBack,
    BlackGradationButton,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentBank: 'bank/currentBank',
    }),
    dispSalePointPrice() {
      if (this.currentBank) {
        return separateCharacterNumber(parseInt(this.currentBank.price, 10));
      }
      return 0;
    },
  },

  created() {
    this.$store.dispatch('bank/setCurrentBank');
  },

  methods: {
    goToTop() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.area_box {
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}
.price {
  color: $mainColor;
}
.bank-transfer-information{
  width: 100%;
  max-width: 1800px;
  min-height: 100%;
  padding: 30px 20px;
  margin: 0px auto;
  text-align: center;
  .text{
    display: inline-block;
    font-family: $notoSans;
    font-size: 16px;
    color: $black;
    white-space: nowrap;
    &.top{
      line-height: 28.8px;
    }
    &.bottom{
      line-height: 32.4px;
    }
  }
  .top-30{
    margin-top: 30px;
  }
  .transfer-information{
    width: 100%;
    .text{
      font-size: 18px;
    }
    .shadow-box{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 10px;
      border-radius: 6px;
      &.value{
        height: 60px;
        font-family: $notoSerif;
        font-size: 30px;
        font-weight: 700;
        color: $black;
      }
      &.bank-account{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 20px;
        font-family: $notoSans;
        font-size: 13px;
        color: $black;
        width: 100%;
        .row{
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          margin: 0px;
          & + .row{
            margin-top: 10px;
          }
          .key{
            text-align: left;
            min-width: 110px;
            font-size: 16px;
          }
          .value{
            font-size: 16px;
            margin-left: 10px;
            font-weight: 700;
          }
        }
      }
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 30px auto 0px;
  }
}
.mt {
  margin-top: 20px;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
@media screen and  (max-width: $tabletWidth) {
  .flex-box {
    .text {
      font-size: 14px;
    }
  }
  .bank-transfer-information {
    padding: 30px 10px;
    .bank-account {
      .row {
        width: 100%;
        flex-direction: column;
        .value{
          margin-left: 0!important;
        }
      }
    }
  }
  .text{
    &.bottom{
      width: 288px;
    }
  }
  .text.sp_text {
    white-space: normal;
  }
}
</style>
